import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { SystemConfig } from '../../config/system-config';
import { SessionService } from '../session/session.service';
import { LoggingService } from '../logging/logging.service';
import { languageFactory } from '../../../app.module';
import { Language } from '../../domain/language';

@Injectable()
export class TranslationService {

    language: string;
    languages: Language[] = [];

    constructor(public http: Http,
                public sessionService: SessionService,
                public loggingService: LoggingService) {
      this.setSupportedLanguages();
    }

    setSupportedLanguages() {
        const l1 = new Language('en', 'English', 'England');
        const l2 = new Language('de', 'Deutsch', 'Germany');
        const l3 = new Language('tr', 'Türk', 'Turkey');
        const l4 = new Language('mk', 'македонски', 'Macedonia');
        const l5 = new Language('ru', 'русский', 'Russia');
        // const l1 = new Language('ru', 'Russian', 'Russia');
        this.languages = [l1, l2, l4, l5];
    }

    translateArgs(key: string, ...args: string[]): string {
        try {
            return this.replaceArgsInTranslation(this.getTranslation(key), ...args);
        } catch (e) {
            this.loggingService.warn(e);
            return '';
        }
    }

    translate(key: string): string {
        try {
            return this.getTranslation(key);
        } catch (e) {
            this.loggingService.warn(e);
            return '';
        }
    }

    async init() {
        this.parseAndSetLanguage();
        let responseEN: Response = <Response> await this.http.get(SystemConfig.Asset.TRANSLATION_EN).toPromise();
        this.sessionService.translations.set(SystemConfig.Constants.LOCALE_EN, responseEN.json());

        let responseDE: Response = <Response> await this.http.get(SystemConfig.Asset.TRANSLATION_DE).toPromise();
        this.sessionService.translations.set(SystemConfig.Constants.LOCALE_DE, responseDE.json());

        let responseMK: Response = <Response>await this.http.get(SystemConfig.Asset.TRANSLATION_MK).toPromise();
        this.sessionService.translations.set(SystemConfig.Constants.LOCALE_MK, responseMK.json());

        let responseRU: Response = <Response>await this.http.get(SystemConfig.Asset.TRANSLATION_RU).toPromise();
        this.sessionService.translations.set(SystemConfig.Constants.LOCALE_RU, responseRU.json());
    }

    private parseAndSetLanguage(): void {
        this.language = languageFactory();

        if (this.language !== 'de' && this.language != 'mk' && this.language != 'ru') {
            this.language = SystemConfig.Constants.LOCALE_DEFAULT;
        }
    }

    private getTranslation(keyString: string): string {
        const keyPath: string[] = keyString.split(SystemConfig.Constants.LOCALE_SEPARATOR);
        return [this.sessionService.translations.get(this.language), ...keyPath].reduce((result: string, key: string) => {
            return result[key];
        });
    }

    private replaceArgsInTranslation(str: string, ...args: string[]) {
        if (args.length === 0 || !str) {
            return '';
        }
        const mapObj: {[key: string]: string} = {};
        args.forEach((arg, idx) => mapObj[SystemConfig.Constants.LOCALE_ARGS + idx] = arg);
        const regExp: RegExp = new RegExp(Object.keys(mapObj).join('|'), 'gi');
        return str.replace(regExp, matched => mapObj[matched.toLowerCase()]);
    }
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/services/translation/translation.service.ts